import axios from "axios";
import React, { useEffect, useState, Fragment } from "react";
import { useParams } from "react-router-dom";
import clientconfigwebapp, {
    empty_bk, convert_to_english_strhk, check_login_appbk, Token_get_appbk, redirectbh_typeb,
} from '../../../clientconfigwebapp';
import { ToastContainer, toast } from 'react-toastify';
import Grid from '@mui/material/Grid';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";


const Tab1_view = (props) => {
    const { Data_Full_Get, setActiveTabCurrent } = props;

    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");
    const [first_name_input, setData_first_name_input] = useState('');
    const [last_name_input, setData_last_name_input] = useState('');
    const [email_address_user, setemail_address_user] = useState('');
    const [email_mobile_number_input, setData_mobile_number_input] = useState('');
    const [description_me_user_input, set_description_me_user_input] = useState('');

    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [filteredCities, setFilteredCities] = useState([]);

    const [selected_activity_cat, setSelected_activity_cat] = useState('');


    useEffect(() => {
        if (selectedProvince) {
            setFilteredCities(cities.filter(city => city.provinceId === selectedProvince));
        } else {
            setFilteredCities([]);
        }
    }, [selectedProvince, cities]);

    useEffect(() => {
        if (!empty_bk(props.Data_Full_Get.first_name_profile)) {
            setData_first_name_input(props.Data_Full_Get.first_name_profile);
        }

        if (!empty_bk(props.Data_Full_Get.last_name_profile)) {
            setData_last_name_input(props.Data_Full_Get.last_name_profile);
        }
        if (!empty_bk(props.Data_Full_Get.email_address_user) && String(props.Data_Full_Get.email_address_user) !== "undefined") {
            setemail_address_user(props.Data_Full_Get.email_address_user);
        } else {
            setemail_address_user('');
        }

        if (!empty_bk(props.Data_Full_Get.mobile_number)) {
            setData_mobile_number_input(props.Data_Full_Get.mobile_number);
        }

        setProvinces(props.provinces);
        setCities(props.cities);

        setSelectedProvince(props.Data_Full_Get.state);
        setSelectedCity(props.Data_Full_Get.city);

        if (selectedProvince) {
            setFilteredCities(cities.filter(city => city.provinceId === selectedProvince));
        } else {
            setFilteredCities([]);
        }

        if (!empty_bk(props.Data_Full_Get.activity_cat)) {
            setSelected_activity_cat(props.Data_Full_Get.activity_cat);
        }

        if (!empty_bk(props.Data_Full_Get.description_me)) {
            set_description_me_user_input(props.Data_Full_Get.description_me);
        }

    }, [props.Data_Full_Get]);

    const Handler_Chanche_input_first_name = (event) => {
        setData_first_name_input(convert_to_english_strhk(event.target.value));
    }

    const Handler_Chanche_last_name_input = (event) => {
        setData_last_name_input(convert_to_english_strhk(event.target.value));
    }

    const Handler_Chanche_email_address_user = (event) => {
        setemail_address_user(String(convert_to_english_strhk(event.target.value)));
    }
    const Handler_Chanche_mobile_number_input = (event) => {
        setData_mobile_number_input(String(convert_to_english_strhk(event.target.value)));
    }

    const Handler_saved_curent_tab = () => {
        if (check_login_appbk() === false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
        }

        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };

        Setloadinghkfullshow("true");

        let form_data = document.querySelector('#form_data_profile');
        if (form_data != null) {
            let formDatanew = new FormData(form_data);
            formDatanew.append("step", "1");
            let data_serialize = new URLSearchParams(formDatanew).toString();

            axios.post(`${clientconfigwebapp.siteurl}api/v1/panel/profile-edit-pr/`, data_serialize, config)
                .then((res) => {
                    Setloadinghkfullshow("false");
                    if (String(res.data).length > 0) {
                        if (String(res.data.data) === "login-show") {
                            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
                        }
                        if (String(res.data.status) === "success") {
                            setActiveTabCurrent('tab2');
                        } else {
                            if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        }
                    } else {
                        if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                }).catch((err) => {
                Setloadinghkfullshow("false");
                toast.error('خطا اتصال به سرور کد  6786324', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
        }
    }

    const Handler_Chanche_description_me_input = (event) => {
        set_description_me_user_input(convert_to_english_strhk(event.target.value));
    }

    return (
        <Fragment>
            <section className='information_content'>
                <div style={{
                    fontSize: "17px",
                    fontWeight: "bold",
                    borderBottom: "solid 1px #e5e7eb",
                    width: "100%",
                    paddingBottom: "12px"
                }}>اطلاعات حساب
                </div>

                <Grid container direction="row" spacing={2} style={{ paddingTop: "14px" }}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <div className="inputbk-container">
                            <label>نام</label>
                            <input
                                name="first_name"
                                className="inputbk"
                                placeholder="نام"
                                value={first_name_input}
                                onChange={Handler_Chanche_input_first_name}
                            />
                        </div>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <div className="inputbk-container">
                            <label>نام خانوادگی</label>
                            <input
                                name="last_name"
                                className="inputbk"
                                placeholder="نام خانوادگی"
                                value={last_name_input}
                                onChange={Handler_Chanche_last_name_input}
                            />
                        </div>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <div className="inputbk-container">
                            <label>ایمیل</label>
                            <input
                                name="email_address_user"
                                className="inputbk"
                                placeholder="ایمیل"
                                value={email_address_user}
                                onChange={Handler_Chanche_email_address_user}
                            />
                        </div>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <div className="inputbk-container">
                            <label>شماره موبایل</label>
                            <input
                                name="phone"
                                className="inputbk"
                                placeholder="شماره موبایل"
                                value={email_mobile_number_input}
                                onChange={Handler_Chanche_mobile_number_input}
                                disabled={true}
                            />
                        </div>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <label>استان</label>
                        <Select
                            value={selectedProvince}
                            onChange={(e) => setSelectedProvince(e.target.value)}
                            displayEmpty
                            name={"state"}
                            className={"select_option_type_activity"}
                        >
                            <MenuItem><span className={"select_option_type_activity_text"}>انتخاب استان </span></MenuItem>
                            {props.provinces && props.provinces.map((item_post, index) => (
                                <MenuItem key={item_post.provinceId} value={String(item_post.provinceId)}>
                                    <span className={"select_option_type_activity_text"}>{item_post.provinceName}</span>
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <label>شهرستان</label>
                        <Select
                            value={selectedCity}
                            onChange={(e) => setSelectedCity(e.target.value)}
                            displayEmpty
                            name={"city"}
                            className={"select_option_type_activity"}
                        >
                            <MenuItem><span className={"select_option_type_activity_text"}>انتخاب شهرستان </span></MenuItem>
                            {filteredCities && filteredCities.map((item_post, index) => (
                                <MenuItem key={item_post.cityId} value={String(item_post.cityId)}>
                                    <span className={"select_option_type_activity_text"}>{item_post.cityName}</span>
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <label>انتخاب حوزه فعالیت</label>
                        <Select displayEmpty name={"activity_cat"} className={"select_option_type_activity"}  value={selected_activity_cat}   onChange={(e) => setSelected_activity_cat(e.target.value)}>
                            <MenuItem><span className={"select_option_type_activity_text"}>انتخاب حوزه فعالیت</span></MenuItem>
                            {props.Data_Full_Get.cat_list_full && props.Data_Full_Get.cat_list_full.map((item_post, index) => (
                                <MenuItem key={index} value={String(item_post.id)}>
                                    <span className={"select_option_type_activity_text"}>{item_post.name}</span>
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <label>درباره کسب و کارتان</label>
                        <textarea
                            name={"description_me"}
                            style={{
                                width: "100%",
                                height: "132px",
                                border: "solid 1px #e4e4e4",
                                borderRadius: "10px",
                                padding: "11px",
                                fontSize: "13px",
                                marginTop: "4px",
                                marginBlock: "4px"
                            }}
                            aria-multiline={8}
                            onChange={Handler_Chanche_description_me_input}
                            value={description_me_user_input}
                            placeholder={""}
                        ></textarea>
                    </Grid>
                </Grid>

                <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                    <button className={"btn-bk-new btn-bk-new-blue btn-full-mobile"} type="button"
                            style={{ marginTop: "10px", marginBottom: "22px" }} onClick={Handler_saved_curent_tab}>
                        ذخیره اطلاعات
                    </button>
                </div>
            </section>
        </Fragment>
    );
}

export default Tab1_view;
